<template>
    <div>
        <h1>RENJA TINDAK LANJUT</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
